export default __webpack_public_path__ + "static/mariana-2e21f05c10a7ed2276d6f63340ceb4aa.webp";